const LEGACY_JOB_IMAGE_PATH_PATTERN = /^\/api\/ai\/jobs\/[^/]+\/image$/;

/**
 * Compatibility helper for persisted history URLs created before Workspace
 * switched to the canonical /media route. New code must use job-media-url.
 */
export function resolveLegacyJobImageProxyUrl(url: string, baseUrl?: string) {
  const defaultBaseUrl =
    baseUrl ??
    (typeof window !== 'undefined' ? window.location.href : 'http://localhost');

  try {
    const target = new URL(url, defaultBaseUrl);
    if (!LEGACY_JOB_IMAGE_PATH_PATTERN.test(target.pathname)) {
      return url;
    }

    target.searchParams.set('proxy', '1');
    return target.toString();
  } catch {
    return url;
  }
}
